var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrakes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    "data-name": "Vrstva 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.08 46.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.05,0H40.3c-.46,0-.83.57-.83,1l0,7.87,4.3,4.35L41.88.87C41.81.47,41.46,0,41.05,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.94,5.6a.74.74,0,0,0-1-.18L44.55,10.5,45,13.31l5-3.5a.81.81,0,0,0,.14-.12L52.9,6.51A.74.74,0,0,0,52.94,5.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.15,24.06l-1.82-1.82c-.35,0-.57,0-.94,0L28.61,24c0,.37,0,.59,0,1l1.82,1.81h.94L33.16,25C33.15,24.61,33.17,24.4,33.15,24.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.94,12.55,35.36,6a1.88,1.88,0,0,0-2.74.1l-4.06,4.64a1.87,1.87,0,0,0,.08,2.56l4,4a2.1,2.1,0,0,1,0,3l-.67.68a.63.63,0,0,0,0,.9l1.89,1.89a1.32,1.32,0,0,0,1.07.38c1.9-.22,7.6-1,9.16-2.54a4.86,4.86,0,0,0,0-6.85ZM35.56,8.71a12.51,12.51,0,0,0-4.48,4.47.46.46,0,0,1-.65,0l-1-1a.45.45,0,0,1,0-.65l4.13-4.82a.46.46,0,0,1,.66,0l1.33,1.33A.47.47,0,0,1,35.56,8.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56,32.92l-7.75,0a.81.81,0,0,0-.81.83v.75a.82.82,0,0,0,.68.83l12.19,1.91Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5,45.34a.75.75,0,0,0,1.1,1l3.17-2.71a.61.61,0,0,0,.13-.15l3.49-5L10.06,38Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.32,23.88,24.5,22.06c-.37,0-.56,0-.93,0l-1.79,1.79c0,.37,0,.57,0,.94l1.81,1.82c.37,0,.58,0,.95,0l1.78-1.78C26.33,24.44,26.31,24.25,26.32,23.88Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.33,25.39a.61.61,0,0,0-.89,0l-.67.68a2.1,2.1,0,0,1-3,0l-4-4A1.88,1.88,0,0,0,10.27,22L5.62,26.06a1.88,1.88,0,0,0-.1,2.75l6.57,6.57,2.12,2.12a4.86,4.86,0,0,0,6.85,0c1.55-1.56,2.32-7.25,2.53-9.16a1.26,1.26,0,0,0-.37-1.06Zm-8.58-.88A12.33,12.33,0,0,0,8.28,29a.47.47,0,0,1-.66,0L6.29,27.64a.46.46,0,0,1,0-.65l4.82-4.13a.47.47,0,0,1,.66,0l1,1A.47.47,0,0,1,12.75,24.51Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrakes);
export default __webpack_public_path__ + "static/media/brakes.778acfea547087ebfb3818da6fd11eb0.svg";
export { ForwardRef as ReactComponent };